import React from 'react'
import LevelTwoCategoryListContainer from '../../../../Components/Category/LevelTwoCategoryListContainer/LevelTwoCategoryListContainer'
import Layout from '../../Layout'

const LevelTwoCategoryListPart = () => {
  return (
    <Layout>
      <LevelTwoCategoryListContainer/>
    </Layout>
  )
}

export default LevelTwoCategoryListPart